import React from 'react';
import { List, Button } from 'antd';
import InfoBar from '@/components/info-bar';
import { CECLOGMONITOR } from '@/constants';

const NGINX_LOGS = ['access', 'iso'];

const AdminLogMonitor = () => {
  return (
    <div>
      <InfoBar
        icon="MCP_app_menu_Metrics"
        color="#099"
        title="Log Monitor Management"
        subtitle="Manage the NGINX Logs"
      />
      <div className="container page white-bg">
        <List split={false}>
          {NGINX_LOGS.map((log) => (
            <List.Item key={log}>
              <Button
                type="text"
                href={`${CECLOGMONITOR}/${log}_report`}
                target="_blank"
              >
                {log.toUpperCase()} Log Report
              </Button>
            </List.Item>
          ))}
        </List>
      </div>
    </div>
  );
};

export default AdminLogMonitor;
